import type { FC } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

import ErrorOverlayWithRefetchButton from 'src/components/dashboard/DashboardPage/components/ErrorOverlayWithRefetchButton';

export const SPEEDOMETER_RE_SKELETON_TEST_ID = 'SPEEDOMETER_RE_SKELETON';

interface SpeedometerReSkeletonProps {
  errorMsg?: string;
  refetch?: () => void;
}

const SpeedometerReSkeleton: FC<SpeedometerReSkeletonProps> = ({
  errorMsg,
  refetch,
}) => (
  <Box
    data-test-id={SPEEDOMETER_RE_SKELETON_TEST_ID}
    sx={{ p: 1, position: 'relative' }}
  >
    <Stack spacing={1} direction="row" sx={{ p: 1 }}>
      <Skeleton
        variant="circular"
        width="8.375rem"
        height="8.375rem"
        sx={{ flexShrink: 0 }}
      />
      <Stack spacing={1} direction="column" sx={{ py: 1.5, width: '100%' }}>
        <Skeleton variant="text" height={45} width="100%" />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="100%" />
      </Stack>
    </Stack>
    {errorMsg && (
      <Box sx={{ minHeight: '3rem' }}>
        <ErrorOverlayWithRefetchButton errorMsg={errorMsg} refetch={refetch} />
      </Box>
    )}
  </Box>
);

export default SpeedometerReSkeleton;
